export const PROFILE_LOGIN_REQUEST = 'Profile/Login/request';
export const PROFILE_LOGIN_SUCCESS = 'Profile/Login/success';
export const PROFILE_LOGIN_FAILURE = 'Profile/Login/failure';

export const PROFILE_AVATAR_UPDATE = 'Profile/Avatar/update';

export const PROFILE_MESSAGE_UPDATE = 'Profile/Message/update';

export const PROFILE_QRURL_UPDATE = 'Profile/QRUrl/update';

export const PROFILE_QRENABLED_UPDATE = 'Profile/QREnable/update';
